import React, { useEffect, useState } from "react";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates_kratos";
import useHttp from "../../../../hook/use-http";
import NoTableData from "./NoTableData";

import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../../redux/userSlice";

export default function ChargingInterruptionDuration_Kratos({ gloablfilter, singleVinSelected }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [vehiclesInterruption, setVehiclesInterruption] = useState([]);
  const [vehiclesDuration, setVehiclesDuration] = useState([]);
  const [vehiclesFaultDuringCharging, setVehiclesFaultDuringCharging] = useState([]);
  const [durationToggle, setDurationToggle] = useState(false)
  const [TBSelected, setTBSelected] = useState('ttt')
  const [interruptionToggle, setInterruptionToggle] = useState(false)

  const charge_interruption = (data) => {
    setVehiclesInterruption(data);
  }
  const fault_duraing_charging = (data) => {
    setVehiclesFaultDuringCharging(data);
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "kratos_charge/charge_interruption_table", body: { filterdata: gloablfilter } }, charge_interruption)
    fetchData({ url: API_URL_MAIN + "kratos_charge/charge_duration_table", body: { filterdata: gloablfilter, durationOrderBy: 'desc' } }, charge_duration)
    fetchData({ url: API_URL_MAIN + "kratos_charge/fault_duraing_charging_table", body: { filterdata: gloablfilter } }, fault_duraing_charging)
  }, [gloablfilter])

  const charge_duration = (data) => {
    setVehiclesDuration(data);
  }

  const [TBText, setTBText] = useState("Top")
  const changeTB = (selectOp) => {
    setTBSelected(selectOp);
    if (selectOp === "ttt") {
      fetchData({ url: API_URL_MAIN + "kratos_charge/charge_duration_table", body: { filterdata: gloablfilter, durationOrderBy: 'desc' } }, charge_duration)
    } else {
      fetchData({ url: API_URL_MAIN + "kratos_charge/charge_duration_table", body: { filterdata: gloablfilter, durationOrderBy: 'asc' } }, charge_duration)
    }

    (selectOp === "ttt") ? setTBText("Top") : setTBText("Bottom")
  }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div className="col-lg-3 col-md-6 col-sm-12 pr-0">
        <div className="chargingChartboxNew_Kratos">
          <div className="v-title chargingTitleChart_Kratos">
            <div className="row p-2">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className=""><b>Charge Interruptions – Top 10 VINs</b></div>
              </div>
            </div>
          </div>
          <div className="tableContent_Kratos px-2" style={{ overflowY: 'scroll', height: '248px' }}>
            <table className="table table-striped">
              <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                <tr>
                  <th scope="col">Vin</th>
                  <th scope="col">Count</th>
                </tr>
              </thead>
              <tbody>

                {(vehiclesInterruption.length == 0) ? <NoTableData /> : vehiclesInterruption.map(x => {
                  return (<tr key={x.key.vehicleId}>
                    <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                    <td>{x.NoOfInterrupt.value}</td>
                  </tr>)
                })}

              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* same code 2 */}
      <div className="col-lg-3 col-md-6 col-sm-12 pr-0">
        <div className="chargingChartboxNew_Kratos">
          <div className="v-title chargingTitleChart_Kratos">
            <div className="row" style={{ padding: '0.2rem' }}>
              <div className="col-lg-8 col-md-8 col-sm-8 col-8 mt-1">
                <b>Charging Dur – {TBText} 10 VINs</b>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                <div className="dropdownSelectBtnCharging_Kratos">
                  <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeTB(event.target.value)}
                    value={TBSelected}>
                    <option value="ttt">Top</option>
                    <option value="bbb">Bottom</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="tableContent_Kratos px-2" style={{ overflowY: 'scroll', height: '248px' }}>
            <table className="table table-striped">
              <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                <tr>
                  <th scope="col">Vin</th>
                  <th scope="col">Mins</th>
                </tr>
              </thead>
              <tbody>
                {(vehiclesDuration.length == 0) ? <NoTableData /> : vehiclesDuration.map(x => {
                  return (<tr key={x.key.vehicleId}>
                    <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                    <td>{(x.chargeDurationInMin.value).toFixed(0)}</td>
                  </tr>)
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* same code 2 */}


      {/* same code 3 */}
      <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="chargingChartboxNew_Kratos">
          <div className="v-title chargingTitleChart_Kratos">
            <div className="row p-2">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className=""><b>Critical Fault During Charging – Top 10 VINs</b></div>
              </div>
            </div>
          </div>
          <div className="tableContent_Kratos px-2" style={{ overflowY: 'scroll', height: '248px' }}>
            <table className="table table-striped">
              <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                <tr>
                  <th scope="col">Vin</th>
                  <th scope="col">Count</th>
                </tr>
              </thead>
              <tbody>
                {(vehiclesFaultDuringCharging.length == 0) ? <NoTableData /> : vehiclesFaultDuringCharging.map(x => {
                  return (<tr key={x.key.vehicleId}>
                    <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                    <td>{x.signal_occurence_count.value}</td>
                  </tr>)
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* same code 3 */}
    </>
  )
}
